import { getApiBaseUrl } from "../../../config";

class PayPalHandler {
    static async createOrder(totalPrice) {
        console.log("Running PayPal createOrder...");
        console.log("Total Price Sent to API:", totalPrice);

        try {
            const response = await fetch(`${getApiBaseUrl()}/create-paypal-order`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ totalPrice }),
            });

            console.log("PayPal API Response Status:", response.status);

            if (!response.ok) {
                throw new Error(`PayPal API request failed with status ${response.status}`);
            }

            const data = await response.json();
            console.log("PayPal API Response Data:", data);

            if (!data.approval_url) {
                console.error("Error: approval_url is missing from the API response.");
                return null;
            }

            console.log("PayPal Approval URL:", data.approval_url);
            return data.approval_url; // Return the PayPal approval URL

        } catch (error) {
            console.error("Error during PayPal order creation:", error);
            throw error;
        }
    }

    static openPayPalWindow(approvalUrl) {
        console.log("Attempting to open PayPal window with URL:", approvalUrl);

        if (!approvalUrl) {
            console.error("Error: Cannot open PayPal window. Approval URL is undefined.");
            return null;
        }

        const paypalWindow = window.open(approvalUrl, '_blank', 'width=800,height=600');

        if (!paypalWindow) {
            console.error("Popup blocker may have prevented opening the PayPal window.");
        } else {
            console.log("PayPal window opened successfully.");
        }

        return paypalWindow;
    }
}

export default PayPalHandler;
